import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { FollowUpApplicationForm } from '@/follow-up-applications/FollowUpApplicationForm';

/**
 * The public Follow-Up Coordinator Application form.
 *
 * The route id must be on `useAuthCheck`'s public-page list, which matches
 * exact route ids, or anonymous visitors are bounced to /login. Top-level
 * rather than under `_app`, so it renders without the app chrome.
 */
export const Route = createFileRoute('/follow-up-coordinator-application')({
  component: FollowUpCoordinatorApplicationPage,
  beforeLoad: () => {
    return {
      pageBackground: 'white',
      noContainer: true,
    };
  },
});

function FollowUpCoordinatorApplicationPage(): ReactElement {
  return <FollowUpApplicationForm applicationRole="coordinator" />;
}
